import Customers from "./Customers";
import useCustomerPageStore from "./store";

export default Customers;

export { useCustomerPageStore };
